import React, { useCallback, useEffect, useState } from 'react';
import OnboardingStep1 from './onboardingStep1';
import OnboardingStep2 from './onboardingStep2';
import { rootStore } from '../../mobx/rootStore';

const Onboarding: React.FC = () => {
  // States
  const [currentStep, setCurrentStep] = useState(1);

  const gotoStep2 = useCallback(() => {
    setCurrentStep(2);
  }, []);

  useEffect(() => {
    return () => {
      rootStore.workspaceStore.clearWorkspaceInputDetail();
    };
  }, []);

  return (
    <>
      {currentStep === 1 && <OnboardingStep1 gotoNext={gotoStep2} />}
      {currentStep === 2 && <OnboardingStep2 />}
    </>
  );
};

export default Onboarding;
